<!--高速公路养护决策分析系统-->
<template>
    <div class="system-container">
        <div class="section">
            <div class="section-content">
                <div class="title">平台概述</div>
                <p class="text">
                    平台关键技术包括可视化驾驶舱、基础数据管理、路产管理、桥涵构造物评价、公路技术状况评价、路面性能预测、养护决策分析等
                    组成。主要作用于辅助管理部门的决策人在综合考虑技术、经济、社会和政治等方面的因素，提供科学的分析工具和方法，辅助分析各项可
                    能的对策，定量地预估各项对策的后效，在预定的标准和约束条件基础上，选用最经济有效的方案。使整个路网达到最佳的路面养护质量和
                    服务水平。
                </p>
                <img class="image" src="@/assets/image/prescription/fun_model2.png" alt />
            </div>
        </div>
        <div class="section" style="background-color: #EAF3FF">
            <div class="section-content">
                <div class="title">核心功能</div>
                <div class="core">
                    <div class="core-list">
                        <div
                            class="core-item"
                            :class="{first:index === 0}"
                            v-for="(item,index) in mobileCoreList"
                            :key="index"
                        >
                            <img class="mobile_image" :src="item.img" alt />
                            <div class="mobile_label">{{ item.label }}</div>
                        </div>
                    </div>
                    <Carousel :images="imageList" />
                </div>
                <!--移动端适配-->
                <div class="mobile-core">
                    <div class="core-list">
                        <div class="core-item" v-for="(item,index) in mobileCoreList" :key="index">
                            <img class="mobile_image" :src="item.img" alt />
                            <div class="mobile_label">{{ item.label }}</div>
                        </div>
                    </div>
                    <el-carousel class="carousel" height="200px" trigger="click">
                        <el-carousel-item v-for="(item,index) in imageList" :key="index">
                            <img
                                :src="item"
                                style="width: 100%;height: 100%;
                                object-fit: scale-down"
                                alt
                            />
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="section-content">
                <div class="title">应用价值</div>
                <div class="panel-content">
                    <div class="panel" v-for="(item,index) in panelList" :key="index">
                        <img class="image" :src="item.icon" style="width: 60px;height: 60px;" alt />
                        <div>
                            <div class="label">{{ item.label }}</div>
                            <p class="info">{{ item.text }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//components
import Carousel from '@/components/Carousel';

export default {
    components: {
        Carousel
    },
    name: 'freewayDecision',
    data() {
        return {
            imageList: [
                require('@/assets/image/prescription/sys_1.png'),
                require('@/assets/image/prescription/sys_2.png'),
                require('@/assets/image/prescription/sys_3.png')
            ],
            panelList: [
                {
                    icon: require('@/assets/image/prescription/icon_20.png'),
                    label: '为上级部门工作提供技术支持',
                    text: '管理部门可通过该平台及时、准确掌握路基、路面、桥隧等全部公路资产的技术状况、养护需求，为上级部门的行业监管、养护决策、资金申请等工作提供有力的技术支持。'
                },
                {
                    icon: require('@/assets/image/prescription/icon_21.png'),
                    label: '实现降本增效',
                    text: '实现公路全寿命养护决策，辅助制定养护计划，科学决策实现降本增效。'
                },
                {
                    icon: require('@/assets/image/prescription/icon_22.png'),
                    label: '发挥资源最佳效益',
                    text: '有效改变传统的经验决策模型，发挥资源的最佳效益，保证路面养护管理决策的系统化、科学化和现代化。'
                }
            ],
            mobileCoreList: [
                { label: '专题“可视化驾驶舱”', img: require('@/assets/image/prescription/icon_20_small.png') },
                { label: '路网数据管理', img: require('@/assets/image/prescription/icon_11_small.png') },
                { label: '路产数据管理', img: require('@/assets/image/prescription/icon_12_small.png') },
                { label: '桥隧构造物评价', img: require('@/assets/image/prescription/icon_14_small.png') },
                { label: '公路技术状况评价', img: require('@/assets/image/prescription/icon_15_small.png') },
                { label: '路面性能预测', img: require('@/assets/image/prescription/icon_16_small.png') },
                { label: '养护决策分析', img: require('@/assets/image/prescription/icon_17_small.png') },
                { label: '养护报告导出', img: require('@/assets/image/prescription/icon_18_small.png') },
                { label: '综合数据统计', img: require('@/assets/image/prescription/icon_19_small.png') },
            ]
        };
    },
    mounted() {
    },
    methods: {
        //切换图片
        toggleImage(type) {
            this.$refs.carousel[type]();
        }
    }
}
</script>


<style scoped lang="scss">
.system-container {
    height: 100%;
    width: 100%;

    .section {
        height: 100%;
        width: 100%;

        .section-content {
            margin: 0 auto;
            width: 1200px;
            padding: 50px 0;
            text-align: center;

            .title {
                text-align: center;
                font-size: 32px;
            }

            .text {
                margin-top: 40px;
                text-indent: 2em;
                line-height: 32px;
                font-size: 20px;
                text-align: justify;
            }

            .image {
                margin-top: 60px;
                width: 1020px;
            }
        }
    }

    .panel-content {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;

        .panel {
            box-sizing: border-box;
            width: calc(100% / 3 - 16px);
            padding: 30px;
            box-shadow: 0 3px 18px 1px rgba(26, 102, 187, 0.14);

            .label {
                padding: 30px 0;
                font-size: 24px;
                font-weight: bold;
            }

            .info {
                line-height: 32px;
                font-size: 20px;
            }
        }
    }

    .mobile-core {
        display: none;
    }

    .core {
        .core-list {
            margin-top: 24px;
            font-size: 20px;
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            grid-template-rows: repeat(2, 1fr);
            grid-gap: 24px;

            .first {
                grid-row-start: 1;
                grid-row-end: 3;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

            .core-item {
                background-color: #ffffff;
                border-radius: 4px;
                padding: 20px;

                .mobile_image {
                    width: 60px;
                    height: 60px;
                }

                .mobile_label {
                    line-height: 30px;
                }
            }
        }
    }
}

@import "./style.scss";
</style>
